export default (width = 24, height = 24, color = '#797979') => `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${width}" height="${height}">
        <path fill="${color}" d="M22.736 12.364c0 .746.147 1.349-.948 1.349H2.74c-1.095 0-.995-.603-.995-1.349s-.1-1.351.995-1.351h19.048c1.095 0 .948.605.948 1.351zM12.292 2.024c.747 0 1.35-.177 1.35.87v18.21c0 1.046-.603.94-1.35.94-.746 0-1.35.106-1.35-.94V2.894c0-1.047.604-.87 1.35-.87z"/>
    </svg>
`


